import React from 'react';
import { Container } from './styles';

const DocumentsSellingPage = () => {
  return (
    <Container>
      <div className="row py-3">
        <div className="col-12">
          <h5 className="p-2 bg-secondary w-100 mb-3 text-white">Documentos de Habilitação</h5>
          <div className="row mb-2">
            <div className="col-12">
              <div className="alert alert-warning text-center" role="alert">
                Você precisa que a ferramenta Gerenciar Documentos esteja ativa para poder utilizar
                essa funcionalidade. <br />
                Conheça os benefícios da ferramenta e fale com um consultor!
              </div>
              <div className="row align-items-center px-3">
                <div className="col-12 col-md-6 text-center">
                  <iframe
                    title="monitoramento-video"
                    id="video"
                    width="100%"
                    height="480"
                    src="https://player.vimeo.com/video/1142414647"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div className="col-12 col-md-6 px-md-5">
                  <h4 className="text-center mb-3">Gerenciar Documentos</h4>
                  <ul className="list-with-check">
                    <li>
                      <span className="oi oi-check" /> Emissão e atualização automática de
                      documentos
                    </li>
                    <li>
                      <span className="oi oi-check" /> Aviso de pendências e vencimentos
                    </li>
                    <li>
                      <span className="oi oi-check" /> Upload manual de arquivos
                    </li>
                    <li>
                      <span className="oi oi-check" /> Acesso rápido e fácil a todos os documentos
                    </li>
                  </ul>
                  <p>
                    <button type="button" className="mt-3 btn btn-primary btn-lg btn-block">
                      Saiba como contratar
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default DocumentsSellingPage;
